module.exports = __webpack_public_path__ + "static/images/Group.93b4aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Group.png
// module id = oBap
// module chunks = 0